module.exports = __webpack_public_path__ + "assets/img/1.2cec4f0b.png";